/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { any, bool } from 'prop-types';

import PazePaymentScript from './PazePaymentScript';
import { PazeProvider } from './PazeContext';

const PazePaymentWrapper = ({ children, isPazeEnabled }) => {
    // create a Paze context with the digitalWalletAdaptor passed in
    // so then can just call context for all the methods of the digitalAdaptor

    if (isPazeEnabled && typeof window !== 'undefined') {
        return (
            <PazeProvider>
                <PazePaymentScript />
                {children}
            </PazeProvider>
        );
    }

    return children;
};

PazePaymentWrapper.propTypes = {
    children: any.isRequired,
    isPazeEnabled: bool.isRequired,
};

export default PazePaymentWrapper;
